<template>
  <div class="delivery-slot-card">
    <label :for="deliverySlot.id" class="radiocontainer">
      <div>
        <p class="delivery-slot-card__date">
          {{ date.toFormat('cccc') }}, {{ date.toFormat('dd/MM/yyyy') }}
        </p>
        <span class="delivery-slot-card__price">
          <span v-if="!deliverySlot.isInStock && order.product.id === 2 && deliverySlot.isFirstDay" class="free">
            Free collection - available from 2pm
          </span>
          <span v-else-if="deliverySlot.price == 0" class="free">Free</span>
          <span v-else>{{ deliverySlot.price | price }}</span>
        </span>
      </div>
      <div class="delivery-slot-card__radio">
        <input type="radio" :id="deliverySlot.id" :value="deliverySlot" :checked="deliverySlot === value"
          @change="select" />
        <span class="tickmark">
          <div class="svg">
            <svg width="24px" height="23px" viewBox="0 0 12 11" version="1.1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-124.000000, -3326.000000)" fill-rule="nonzero" stroke="var(--color-primary)">
                  <path
                    d="M134.854266,3327.0501 C134.706927,3326.95592 134.510342,3326.99846 134.415838,3327.14467 L128.455086,3335.15954 C128.372345,3335.28695 128.263685,3335.36174 128.149243,3335.36965 C128.033804,3335.37678 127.917169,3335.31841 127.817281,3335.20267 L125.558149,3332.5875 C125.444305,3332.45593 125.243932,3332.4403 125.110749,3332.55347 C124.977765,3332.66644 124.962413,3332.86548 125.076257,3332.99744 L127.335389,3335.61281 C127.550117,3335.86091 127.836222,3336 128.129504,3336 C128.150638,3336 128.171573,3335.99941 128.192707,3335.99763 C128.507721,3335.97606 128.797614,3335.79463 128.988816,3335.49964 L134.949369,3327.48537 C135.044471,3327.33896 135.001605,3327.14427 134.854266,3327.0501 Z">
                  </path>
                </g>
              </g>
            </svg>
          </div>
        </span>
      </div>
    </label>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import { DateTime } from 'luxon'

export default {
  name: 'DeliverySlotCard',
  props: ['value', 'deliverySlot'],
  methods: {
    select(e) {
      if (e.target.checked) this.$emit('input', this.deliverySlot)
    }
  },
  computed: {
    ...mapState({
      order: (state) => state.checkout.order,
    }),
    date() {
      return DateTime.fromISO(this.deliverySlot.date)
    }
  },
}
</script>

<style lang="scss">
.delivery-slot-card {
  border: solid 1px var(--color-borders);
  margin-bottom: 10px;
  padding: 1rem;

  &__date {
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 5px;
  }

  &__radio {
    position: relative;
    width: 24px;
    height: 24px;
  }
}
</style>
